import { ClaimedTask } from '../../tasks/models/claimed-task-object.model';
import { SearchResult } from '../search/models/search-result.model';

/**
 * Represents a search result object of an Approved ClaimedTask object
 */
export class ClaimedApprovedTaskSearchResult extends SearchResult<ClaimedTask> {
}
